import Chart from 'react-apexcharts';

function DualBarChart({
  title = '',
  categories = [],
  series = [],
  width = 400,
  height = 310,
  min = 0,
  suffix = '',
}) {
  const allValues = series.flatMap((s) => s.data.map((d) => d.y));
  const minValue = Math.min(...allValues);
  const maxValue = Math.max(...allValues);

  const options = {
    title: {
      text: title,
    },
    chart: {
      type: 'bar',
      animations: { enabled: false },
      stacked: false,
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      labels: {
        rotateAlways: true,
      },
    },
    yaxis: {
      min: minValue < min ? minValue : min,
      max: maxValue,
      labels: {
        style: {
          fontSize: '10px',
        },
        formatter: (val) => `${val.toFixed(0)}${suffix}`,
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (val) => `${parseFloat(val.toFixed(1))}${suffix}`,
      },
    },
    grid: {
      padding: {
        bottom: -15,
      },
    },
  };

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      width={width}
      height={height}
    />
  );
}

export default DualBarChart;
